import DateTime from 'components/content/DateTime';
import NoData from 'components/content/NoData';
import { isDate } from 'remeda';

export interface DateTimeOrNoDataProps {
    value?: string | null;
    separator?: boolean;
}

const DateTimeOrNoData = ({ value, separator }: DateTimeOrNoDataProps) =>
    value && isDate(new Date(value)) ? (
        <p className='w-max flex-1-1'>
            <DateTime date={new Date(value)} separator={separator} />
        </p>
    ) : (
        <NoData text='No data' className='flex-1-1 text-14' />
    );

export default DateTimeOrNoData;
